import { getPayoutsByCriteria } from '@nemuru-eng/js-api-client';

import { fetchForDataGrid } from '@/utils/fetchForDataGrid';

export function usePayoutsList() {
  const fetchPayoutsList = async (query) => {
    const customFilters = query?.filters;
    return fetchForDataGrid(getPayoutsByCriteria, { ...query, filters: customFilters });
  };

  return {
    fetchPayoutsList,
  };
}
